// extracted by mini-css-extract-plugin
module.exports = {"title":"DiskCategory_title__oU3bA","button":"DiskCategory_button__9EObA","radio":"DiskCategory_radio__nJs64"};